import React from 'react';
import PropTypes from 'prop-types';
import { CheckCircleFilled, WarningFilled } from "@ant-design/icons";
import { Badge } from 'antd'; // Import Ant Design Badge component

// Utility function to determine the color based on value
const getColor = (value, belowValue, aboveValue) => {
    if (value < belowValue.value) {
        return belowValue.color;
    } else if (value > aboveValue.value) {
        return aboveValue.color;
    }
    return 'black'; // default color
};

// Utility function to determine the tag based on value and ranges
const getTag = (value, ranges) => {
    for (let range of ranges) {
        if (value >= range.min && value <= range.max) {
            return range.tag;
        }
    }
    return null;
};

const ContextualStat = ({
    label,
    value,
    belowValue = { value: 0, color: '#EB7E7E' },
    aboveValue = { value: 0, color: '#02AF50' },
    ranges = [],
    valueSize = 18,
    tagSize = 14,
    labelSize = 13,
    labelColor = '#333',
    prefix = '',
    suffix = '',
    showIcon = true,
    AboveIcon = CheckCircleFilled,
    BelowIcon = WarningFilled
}) => {
    const color = getColor(value, belowValue, aboveValue);
    const tag = getTag(value, ranges);

    const Icon = () => {
        if (value < belowValue.value) return <BelowIcon style={{ color: belowValue.color }} />;
        if (value > aboveValue.value) return <AboveIcon style={{ color: aboveValue.color }} />;
        return null;
    };

    return (
        <div>
            {label &&
                <div style={{ background: 'white', padding: '2px 5px', fontSize: labelSize, color: labelColor, fontFamily: 'var(--font-family)', fontWeight: '600' }}>
                    {showIcon && <Icon />} {label}
                </div>
            }
            <span style={{ color, fontSize: valueSize }}>
                {prefix}{value}{suffix}
                {tag && (
                    <Badge
                        count={tag}
                        style={{
                            backgroundColor: color, // Use the color associated with the value
                            fontSize: tagSize,
                            marginLeft: 8, // Add some space between value and badge
                        }}
                    />
                )}
            </span>
        </div>
    );
};

ContextualStat.propTypes = {
    label: PropTypes.string,
    value: PropTypes.number.isRequired,
    belowValue: PropTypes.shape({
        value: PropTypes.number,
        color: PropTypes.string
    }),
    aboveValue: PropTypes.shape({
        value: PropTypes.number,
        color: PropTypes.string
    }),
    ranges: PropTypes.arrayOf(PropTypes.shape({
        min: PropTypes.number.isRequired,
        max: PropTypes.number.isRequired,
        tag: PropTypes.string.isRequired
    }))
};

export default ContextualStat;
